import { useTranslation } from 'react-i18next';
import Icon from '../../ui/Icon/Icon';
import ProjectRows from '../ProjectRows/ProjectRows';
import type { Project } from '../../../data/projects';
import styles from './LabShelf.module.css';

type HeadingTag = 'h2' | 'h3';

interface LabShelfProps {
    projects: Project[];
    headingId: string;
    headingTag?: HeadingTag;
}

export default function LabShelf({ projects, headingId, headingTag: Heading = 'h2' }: LabShelfProps) {
    const { t } = useTranslation();

    return (
        <section className={styles.shelf} aria-labelledby={headingId}>
            <div className={styles.intro}>
                <Heading id={headingId} className={styles.title}>
                    <Icon name="flask" className={styles.icon} />
                    {t('lab.title')}
                </Heading>
                <p className={styles.lead}>{t('lab.lead')}</p>
            </div>
            <ProjectRows projects={projects} />
        </section>
    );
}
